"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const droits_1 = require("views/droits");
const globals_1 = require("models/globals");
class DroitsAdmin extends droits_1.default {
    constructor(app, name) {
        super(app, name, {
            columnData: [
                { id: "unid", name: "unid", header: (0, globals_1._)("#"), width: 50 },
                { id: "parentId", header: (0, globals_1._)("Père"), width: 50 },
                { id: "libelle", header: (0, globals_1._)("Libellé"), width: 200,
                    template: "{common.treetable()} #libelle#" },
                { id: "accessType", header: (0, globals_1._)("Type"), width: 120, options: [
                        { "id": "Menu", "value": (0, globals_1._)("Menu") },
                        { "id": "Fonction", "value": (0, globals_1._)("Fonction") }
                    ]
                },
                { id: "description", header: (0, globals_1._)("Description"), width: 500 },
                { id: "accessKey", header: (0, globals_1._)("Clé"), width: 200, sort: "text" },
                { id: "editeur", template: "{common.checkbox()}", header: (0, globals_1._)("Editeur"), width: 80, value: "0", uncheckValue: "0", checkValue: "1" },
                { id: "lecteur", template: "{common.checkbox()}", header: (0, globals_1._)("Lecteur"), width: 80, value: "0", uncheckValue: "0", checkValue: "1" }
            ]
        });
    }
    init() {
        this.moduleName = "droitsAdmin";
        super.init();
    }
}
exports.default = DroitsAdmin;
